let YourLifestyle = Backbone.Model.extend(
    {
        defaults:
            {
                activities: null,
            },

        initialize: function () {
            let loadLifestyleActivities = new LifestyleActivityList(
                unpackList(this.getActivities(), CreateLifestyleActivity));
            let lifestyleActivities = new LifestyleActivityList();

            _.each(appConfig.lifestyle.activities, function (lifestyleActivity) {
                lifestyleActivities.add(
                    new LifestyleActivity({name: lifestyleActivity}).loadIn(loadLifestyleActivities));
            });
            this.set('activities', lifestyleActivities);
        },

        getActivities: function () {
            return this.get('activities');
        },

        averageUtilisedHours: function () {
            let hours = 0;

            this.getActivities().each(function (activity) {
                if(activity.isSelected()) {
                    hours += activity.averageUtilisedHours();
                }
            });

            return hours;
        }
    }
);
